import { render } from "./RPPItem.vue?vue&type=template&id=80c7765a&scoped=true&ts=true"
import script from "./RPPItem.vue?vue&type=script&lang=ts"
export * from "./RPPItem.vue?vue&type=script&lang=ts"

import "./RPPItem.vue?vue&type=style&index=0&id=80c7765a&lang=scss&scoped=true"

import exportComponent from "/builds/spark/services/frontend/admin-v2/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80c7765a"]])

export default __exports__